import { render } from "./myfooter.vue?vue&type=template&id=7b181e67"
import script from "./myfooter.vue?vue&type=script&lang=js"
export * from "./myfooter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/oralhealthmap.uz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__